
export const evArea = {
    backgroundColor: '#084e47',
    borderRadius: 3,
    padding: '2% 0',
    lineHeight: 2
};
export const evTitle = {
    display: 'flex',
    justifyContent: 'start',
};
export const evImg = {
    height: 45,
    width: 45,
    // padding: '2% 4%'
    padding: '2% 2% 2% 4%',
};
export const evText = {
    // paddingTop: '1.5%',
    padding: '2% 4% 0 2%',
    lineHeight: 1,
};
export const evButton = {
    textAlign: 'right',
    marginRight: '4%',
    display: 'flex',
    flexDirection: 'row-reverse'
};

export const selectEvButton = {
    backgroundColor:'rgba(255,255,255,0.15)',
    color:'#FAFAFA',
    fontSize:'1.2rem',
    display: 'block',
};
export const noEvButton = {
    backgroundColor:'rgba(0,0,0,0)',
    color:'rgba(238, 238, 238,0.57)',
    fontSize:'1.2rem',
    display: 'block',
};



// WEBPACK FOOTER //
// ./src/components/footer/evStyle.js